import type { ScriptReviewAiEnvelope, ScriptReviewTaskResponse } from './types';

export function taskResponseToEnvelope(
  task: ScriptReviewTaskResponse | undefined,
): ScriptReviewAiEnvelope | undefined {
  if (!task) return undefined;
  if (task.status === 'SUCCESS' && task.result) {
    return {
      status: 'complete',
      analysis_id: task.analysis_id,
      data: task.result,
    };
  }
  if (task.status === 'FAILURE') {
    return {
      status: 'failed',
      analysis_id: task.analysis_id,
      error: task.error ?? 'Script review failed',
    };
  }
  return { status: 'pending', analysis_id: task.analysis_id };
}
